// Please prefix all keys with `error` to not get confilcts with other translations.
export default {
	en: {
		date: {
			monday: 'monday',
			tuesday: 'tuesday',
			wednesday: 'wednesday',
			thursday: 'thursday',
			friday: 'friday',
			saturday: 'saturday',
			sunday: 'sunday',
			january: 'january',
			february: 'february',
			march: 'march',
			april: 'april',
			may: 'may',
			june: 'june',
			july: 'july',
			august: 'august',
			september: 'september',
			october: 'october',
			november: 'november',
			december: 'december',
		},
	},
	de: {
		date: {
			monday: 'Montag',
			tuesday: 'Dienstag',
			wednesday: 'Mittwoch',
			thursday: 'Donnerstag',
			friday: 'Freitag',
			saturday: 'Samstag',
			sunday: 'Sonntag',
			january: 'Januar',
			february: 'Februar',
			march: 'Februar',
			april: 'April',
			may: 'Mai',
			june: 'Juni',
			july: 'Juli',
			august: 'August',
			september: 'September',
			october: 'Oktober',
			november: 'November',
			december: 'Dezember',
		},
	},
};
